   /**
    * Created by BFR on 23/05/2017.
 */
define('restransDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'restransDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var ResTransDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showResTransInfo(data);
    },

    showResTransInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('restransDetailTab').show(view);
    }
  };

  module.exports = ResTransDetailTabController;
});
